var React = require('react');

function DarkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"}));
}

DarkIcon.defaultProps = {"viewBox":"0 0 24 24","width":"32","height":"32","stroke":"currentColor","strokeWidth":"2","fill":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","xmlnsSvg":"http://www.w3.org/2000/svg"};

module.exports = DarkIcon;

DarkIcon.default = DarkIcon;
